module.exports = "<app-marketing  [isCallCentreQuotable]=true>\n</app-marketing>\n"